import { action } from 'mobx';
import BaseStore from 'core/stores/BaseStore';
import { WarehouseActivityService } from 'common/data';

class WarehouseActivityStore extends BaseStore {
	constructor(rootStore) {
		super(new WarehouseActivityService(rootStore.app.baasic.apiClient));
	}

	@action async findWarehouseActivity(filter) {
		const response = await this.service.find(filter);
		if (filter && filter.search) {
			response.data.searchQuery = filter.search;
		}
		this.response = response.data;
	}

	@action async getWarehouseActivity(id, options) {
		const warehouse = await this.service.get(id, options);
		this.item = warehouse.data;
	}

	@action async updateWarehouseActivity(warehouseActivity) {
		await this.service.update(warehouseActivity);
	}

	@action async createWarehouseActivity(warehouseActivity) {
		const response = await this.service.create(warehouseActivity);
		this.item = response;
		return this.item.data;
	}

	@action async adjustInventory(warehouseActivities, sourceOfChange) {
		const response = await this.service.adjustInventory(warehouseActivities, sourceOfChange);
		this.item = response;
		return this.item.data;
	}

	@action async deleteWarehouseActivity(warehouseActivity) {
		warehouseActivity = { id: warehouseActivity.id };
		await this.service.delete(warehouseActivity);
	}
}

export default WarehouseActivityStore;



// WEBPACK FOOTER //
// ./src/modules/warehouse/stores/WarehouseActivityStore.js